import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Header from 'core/components/Header';
import Footer from 'core/components/Footer';

import Home from './pages/Home';
import Galleries from './pages/Galleries';
import About from './pages/About';

class App extends Component {
    render() {
        return (
            <BrowserRouter>
                <div className="container px3">
                    <Header />
                    <Switch>
                        <Route path="/" exact component={Home} />
                        <Route path="/galleries" component={Galleries} />
                        <Route path="/about" component={About} />
                        <Route render={() => <div className="mt2 mb3">404: Page not found!</div>} />
                    </Switch>
                    <Footer />
                </div>
            </BrowserRouter>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js